module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/costume_type_western_clothing@2x-5dfc3c0696de64608864912210e979c5.webp";